import {RequestPOIInfoItem} from "./RequestPOIInfoItem";

export interface RequestDetailsItem {
    id: number;
    requestNo: string;
    reasonForRequest: string;
    euSecLegBasis: string;
    infoRequested: string;
}

export function initRequestDetailsItem(): RequestDetailsItem {
    return {
        id: 0,
        requestNo: '',
        reasonForRequest: '',
        euSecLegBasis: '',
        infoRequested: '',
    };
}